export const prefix = (selector: string) => `ccsu-${selector}`

export const dataHook = (selector: string) => `data-hook="${prefix(selector)}"`

export const byHook = (selector: string) => `[${dataHook(selector)}]`

export const  dataCompType = (selector: string) => `data-comp-type="${selector}"` 
